(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rivox-collection"] && !Shopify.designMode) return;
  try {
    
function initRivoxCollectionFilters(){
 document.querySelectorAll('.rv-collection').forEach(root=>{
  if(root.dataset.filtersReady)return;
  const flavor=root.querySelector('[data-rv-flavor]'),pack=root.querySelector('[data-rv-pack]');
  if(!flavor||!pack)return;
  root.dataset.filtersReady='true';
  const cards=Array.from(root.querySelectorAll('.rv-collection__card'));
  function apply(){
   let shown=0;
   cards.forEach(card=>{
    const title=card.dataset.rvTitle,handle=card.dataset.rvHandle;
    const mix=/variety|build your|build-your|starter/.test(title+' '+handle);
    const flavorOK=flavor.value==='all'||(flavor.value==='variety'?mix:title.includes(flavor.value)||mix);
    let size='single';
    if(/starter|kit/.test(title))size='starter';
    else if(/12[- ]?pack|twelve/.test(title))size='12';
    else if(/5[- ]?pack|five[- ]pack/.test(title))size='5';
    else if(/pack/.test(title))size='other';
    const visible=flavorOK&&(pack.value==='all'||pack.value===size);
    card.hidden=!visible;if(visible)shown++;
   });
   root.querySelector('[data-rv-empty]').hidden=shown>0;
  }
  flavor.addEventListener('change',apply);pack.addEventListener('change',apply);
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRivoxCollectionFilters);else initRivoxCollectionFilters();
document.addEventListener('shopify:section:load',initRivoxCollectionFilters);

  } catch(e) { console.error(e); }
})();
})();
